import React, { Component } from "react";
import NewUser from "./NewUser";
import UpdateUser from "./UpdateUser";
import { ErrorCode, RoleGroupId, AccountTypeName } from "../../const";
import * as Business from "../../utils/business";
import * as Http from "../../http";
import Loading from "../../components/Loading";
import { ButtonToolbar, Button, DropdownButton } from "react-bootstrap";

export default class ListRole extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: [],
    };
  }

  componentDidMount() {
    this.getListRole();
  }

  getListRole = () => {
    Http.queryRoleGroup().then(() => {
      this.setState({
        loading: false,
        data: Http.getRoleGroup(),
      });
    });
  };

  deleteItem = (username) => {
    this.setState({
      data: this.state.data.filter((item) => item.username !== username),
    });
  };

  onRoleChange = () => {
    this.getListRole();
  };

  renderRow = (item) => {
    const lstRolesToDisplay = Business.getRawListRole();
    const lstRoleFromDatabase = JSON.parse(item.RoleList) || [];

    for (let i = 0; i < lstRolesToDisplay.length; i++) {
      const roleToDisplay = lstRolesToDisplay[i];
      const roleFromDatabase = lstRoleFromDatabase.find(
        (e) =>
          e.roleId === roleToDisplay.roleId &&
          e.roleName === roleToDisplay.roleName
      );
      if (roleFromDatabase) {
        roleToDisplay.select = roleFromDatabase.select;
      }
    }

    return (
      <tr key={item.RoleGroupId}>
        {Business.isHasRole([Business.ROLE_DEFINE_MAP.UPDATE_ROLE]) ? (
          <td>
            <a
              rel="tooltip"
              className="btn btn-info btn-simple btn-xs"
              data-original-title="View Profile"
              onClick={() => {
                this.updateUserRef.show(item);
              }}
            >
              {item.RoleGroupName}
            </a>
          </td>
        ) : (
          <td> {item.RoleGroupName} </td>
        )}
        {lstRolesToDisplay.map((item) => (
          <td>
            <input
              className="form-check-input"
              type="checkbox"
              id="inlineCheckbox3"
              value="option3"
              disabled
              checked={item.select === "1"}
            />
          </td>
        ))}
      </tr>
    );
  };

  render() {
    if (this.state.loading)
      return (
        <div style={{ height: Business.getHeightContent() }}>
          <Loading size="small" />
        </div>
      );

    return (
      Business.isHasRole([
        Business.ROLE_DEFINE_MAP.CREATE_ROLE,
        Business.ROLE_DEFINE_MAP.UPDATE_ROLE,
      ]) && (
        <div className="card">
          <NewUser
            ref={(ref) => (this.newUserRef = ref)}
            onRoleChange={this.onRoleChange}
          />
          <UpdateUser
            ref={(ref) => (this.updateUserRef = ref)}
            onRoleChange={this.onRoleChange}
          />
          <div className="header">
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <h4 className="title" tyle={{ fontSize: 20 }}>
                Role
              </h4>
              {Business.isHasRole([Business.ROLE_DEFINE_MAP.CREATE_ROLE]) && (
                <ButtonToolbar>
                  <Button
                    bsSize="small"
                    className="file-button approve-button"
                    style={{
                      height: 40,
                    }}
                    onClick={() => this.newUserRef.show()}
                  >
                    {`+  Create Role`}
                  </Button>
                </ButtonToolbar>
              )}
            </div>
          </div>
          <div style={{ height: 15 }} />
          <div className="content table-responsive table-full-width">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "20px",
                gap: 8,
              }}
            >
              <input
                type="text"
                style={{
                  height: "44px",
                  flex: 1,
                  backgroundColor: "#ffffff",
                  border: "1px solid #D9D9D9",
                  borderRadius: 8,
                }}
                className="form-control"
                id="search_content"
                onChange={(event) => {
                  this.setState({ searchValue: event.target.value });
                }}
                placeholder="Search username"
              />
              <div style={{ display: "inline" }}>
                <DropdownButton
                  title={<i className="pe-7s-filter"></i>}
                  bsSize="small"
                  id={`dropdown-size-${1}`}
                  style={{
                    height: 44,
                    border: "1px solid #767676",
                    borderRadius: 8,
                    color: "#1E1E1E",
                    backgroundColor: "#E3E3E3",
                  }}
                ></DropdownButton>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "#1E1E1E",
                }}
              >
                <button
                  type="button"
                  disabled={this.state.progressValue > 0}
                  className="btn btn-primary"
                  style={{
                    color: "#1E1E1E",
                    backgroundColor: "#E3E3E3",
                    borderRadius: "8px",
                    fontSize: 16,
                    fontWeight: 400,
                    marginLeft: "auto",
                    float: "left",
                    height: "44px",
                    border: "1px solid #767676",
                  }}
                  onClick={() => this.search()}
                >
                  <i
                    className="pe-7s-search"
                    style={{ fontSize: 16, marginRight: 8 }}
                  ></i>
                  Search
                </button>
              </div>
            </div>
            <table className="table table-hover table-striped">
              <thead>
                <tr>
                  <th style={{ width: 64 }}>No. </th>
                  <th>Role name</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {Business.getAllReportName().map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item}</td>
                    <td className="text-right">
                      <div style={{ display: "flex", gap: 4 }}>
                        <div className="buttons-container">
                          {Business.isHasRole([
                            Business.ROLE_DEFINE_MAP.UPDATE_ROLE,
                          ]) ? (
                            <a
                              rel="tooltip"
                              className="btn btn-info btn-simple btn-xs delete-button"
                              data-original-title="edit user"
                            >
                              <i
                                style={{ fontSize: 20, color: "#535862" }}
                                className="pe-7s-pen"
                              ></i>
                            </a>
                          ) : (
                            <div></div>
                          )}
                        </div>
                        <div className="buttons-container">
                          {Business.isHasRole([
                            Business.ROLE_DEFINE_MAP.UPDATE_ROLE,
                          ]) ? (
                            <a
                              rel="tooltip"
                              className="btn btn-info btn-simple btn-xs delete-button"
                              data-original-title="delete user"
                            >
                              <i
                                style={{ fontSize: 20, color: "#535862" }}
                                className="pe-7s-trash"
                              ></i>
                            </a>
                          ) : (
                            <div></div>
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Role/ListRole.js